import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import TimeEntry from './TimeEntry';
import WorkerCalendar from './WorkerCalendar';
import UpdateNotification from './UpdateNotification';
import './WorkerShell.css';

type WorkerView = 'timeentry' | 'calendar';

const WorkerShell: React.FC = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState<WorkerView>('timeentry');
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  // Listen for service worker updates
  useEffect(() => {
    const handleUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<ServiceWorkerRegistration>;
      const registration = customEvent.detail;
      if (registration && registration.waiting) {
        setWaitingWorker(registration.waiting);
        setShowUpdateNotification(true);
      }
    };

    window.addEventListener('swUpdate', handleUpdate);
    return () => window.removeEventListener('swUpdate', handleUpdate);
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    setShowUpdateNotification(false);
  };

  return (
    <div className="worker-shell">
      {showUpdateNotification && (
        <UpdateNotification
          onUpdate={handleUpdate}
          onDismiss={() => setShowUpdateNotification(false)}
        />
      )}

      <header className="worker-header">
        <div className="worker-header-left">
          <h1 className="worker-title">Stundenerfassung</h1>
        </div>
        <nav className="worker-nav">
          <button
            className={`nav-tab ${activeView === 'timeentry' ? 'active' : ''}`}
            onClick={() => setActiveView('timeentry')}
          >
            Zeiten erfassen
          </button>
          <button
            className={`nav-tab ${activeView === 'calendar' ? 'active' : ''}`}
            onClick={() => setActiveView('calendar')}
          >
            Kalender
          </button>
        </nav>
        <div className="worker-header-right">
          <span className="worker-name">{user?.name}</span>
          <button className="btn-logout" onClick={logout}>Abmelden</button>
        </div>
      </header>

      <main className="worker-content">
        {activeView === 'timeentry' && <TimeEntry />}
        {activeView === 'calendar' && <WorkerCalendar />}
      </main>
    </div>
  );
};

export default WorkerShell;
